import { Select } from 'antd'
import React, { useEffect } from 'react'
import Loader from '../pages/pages/loader'
import { toast } from 'react-toastify'
import { useGetAppStoresListQuery } from '../redux/apis/linkManagement/app/stores/lmAppsStoresApiSlice'

const AppStoreDropdown = ({
  onChange,
  onBlur,
  value,
  className = '',
  mode=''
}) => {
  const { data, isLoading, error } = useGetAppStoresListQuery({
    page: '*',
    fields: ['id','app_store_name'].join(','),
  })

useEffect(()=>{
        if ( !error && !isLoading) {
            return
        }
        toast.error(error)
    },[error, isLoading])

  return (
    <div className=' mb-3'>
      <Loader isLoading={isLoading} />
      <label className="form-label">App Store</label>
      <br />
      <Select
        name='app_store'
        className={className}
        showSearch
        style={{
          width: '100%'
        }}
        optionFilterProp='label'
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '')
            .toLowerCase()
            .localeCompare((optionB?.label ?? '').toLowerCase())
        }
        defaultValue={value}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        loading={isLoading}
        options={data?.data?.results?.map(x => {
          return { label: x.app_store_name, value: x.id }
        })}
        mode={mode}
      />
    </div>
  )
}

export default AppStoreDropdown
